import { PlusSVG } from '../../../svgComponents/plusSVG';

export const CreateNewCard = ({ label, onClick, ...props }) => {
    return (
        <div
            className="flex flex-col items-center justify-center space-y-m rounded-s bg-structure-100 px-s py-2xl shadow-black-s hover:cursor-pointer hover:shadow-black-m"
            onClick={onClick}
            data-testid={props['data-testid']}
            role="button"
            tabIndex="0"
        >
            <PlusSVG />
            <div>{label}</div>
        </div>
    );
};
